/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Topical_Orange_Husky_RenewInputs */

const fr_topical_orange_husky_renew = /** @type {(inputs: Topical_Orange_Husky_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe oublié ?`)
};

/**

* @param {Topical_Orange_Husky_RenewInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const topical_orange_husky_renew = /** @type {((inputs?: Topical_Orange_Husky_RenewInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Topical_Orange_Husky_RenewInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_topical_orange_husky_renew(inputs)
});